/**
 * Copyright (c) 2018 - present, Inbenta Technologies Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */

(function () {
  /**
   * Function to display rating comment step.
   */
  function displayMoreNews(allNews) {
    let nbToShow = 10;

    // Get months  to display
    for (let i = 0; i < allNews.length; i++) {
      if (allNews[i].classList.contains('inbenta-km__faq--hidden') && nbToShow > 0) {
        allNews[i].classList.remove('inbenta-km__faq--hidden');
        nbToShow--;
      }
    }
    updateLoader();
  }

  function updateLoader() {
    let allNews = document.querySelectorAll('.inbenta-km__news .inbenta-km__faq').length;
    let hiddenNews = document.querySelectorAll('.inbenta-km__news .inbenta-km__faq--hidden').length;
    let shownNews = allNews - hiddenNews;

    document.querySelector('.inbenta-km__news__loader .loader-text__count').textContent = shownNews;
    const totalArticles = document.querySelector('.inbenta-km__news__loader .loader-text__total')
    const loadedWidth = parseInt(shownNews) * 224 / totalArticles.innerHTML
    const bar = document.querySelector('.inbenta-km__news .inbenta-km__news__loader .inbenta-km__news__loader-bar-progression')
    bar.style.width = Math.round(loadedWidth) + 'px';

    if (hiddenNews === 0) {
      hideLoaderButton();
    }
  }

  function hideLoaderButton() {
    var seeMorebutton = document.querySelector('.inbenta-km__news .inbenta-km__news__loader .button--secondary--yellow')
    seeMorebutton.style.display = 'none'
  }

  /**
   * Main function.
   */
  window.addEventListener('load', function () {
    if (document.querySelectorAll('.inbenta-km__news').length && document.querySelectorAll('.inbenta-km__news__loader').length) {
      var allNews = document.querySelectorAll('.inbenta-km__news .inbenta-km__faq');
      if (allNews) {
        displayMoreNews(allNews);
        var seeMorebutton = document.querySelector('.inbenta-km__news .inbenta-km__news__loader .button--secondary--yellow')
        seeMorebutton.addEventListener('click', function () {
          displayMoreNews(allNews)
        })
      }
    }
  });
})()
